import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { tabsInjectionKey as nt } from "./interface.js";
import st from "./styles/index.cssr.js";
import ne from "./Tab.js";
import it from "../../_mixins/use-config.js";
import ve from "../../_mixins/use-theme.js";
import ce from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-compitable.js";
import { flatten as q } from "../../_utils/vue/flatten.js";
import lt from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import J from "../../../../../../lodash-es@4.17.21/node_modules/lodash-es/throttle.js";
import ot from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/on-fonts-ready.js";
import { createKey as $ } from "../../_utils/cssr/index.js";
import { getMargin as U, depx as rt } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as dt } from "../../_mixins/use-css-vars-class.js";
import { resolveWrappedSlot as ue } from "../../_utils/vue/resolve-slot.js";
import Q from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/resize-observer/src/VResizeObserver.js";
import ft from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/x-scroll/src/index.js";
import { warnOnce as Y } from "../../_utils/naive/warn.js";
import ct from "../styles/light.js";
import { call as G } from "../../_utils/vue/call.js";
import { defineComponent as ut, watchEffect as pe, computed as Z, watch as ee, nextTick as te, onMounted as pt, provide as bt, h as i, withDirectives as ht, cloneVNode as mt } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as u, toRef as T } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { vShow as vt, TransitionGroup as gt } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const yt = Object.assign(Object.assign({}, ve.props), {
  value: [String, Number],
  defaultValue: [String, Number],
  trigger: {
    type: String,
    default: "click"
  },
  type: {
    type: String,
    default: "bar"
  },
  closable: Boolean,
  justifyContent: String,
  size: {
    type: String,
    default: "medium"
  },
  placement: {
    type: String,
    default: "top"
  },
  tabStyle: [String, Object],
  tabClass: String,
  addTabStyle: [String, Object],
  addTabClass: String,
  barWidth: Number,
  paneClass: String,
  paneStyle: [String, Object],
  paneWrapperClass: String,
  paneWrapperStyle: [String, Object],
  addable: [Boolean, Object],
  tabsPadding: {
    type: Number,
    default: 0
  },
  animated: Boolean,
  onBeforeLeave: Function,
  onAdd: Function,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onClose: [Function, Array],
  // deprecated
  labelSize: String,
  activeName: [String, Number],
  onActiveNameChange: [Function, Array]
}), kt = ut({
  name: "Tabs",
  props: yt,
  slots: Object,
  setup(a, {
    slots: r
  }) {
    var m, W, v, _;
    process.env.NODE_ENV !== "production" && pe(() => {
      a.labelSize !== void 0 && Y("tabs", "`label-size` is deprecated, please use `size` instead."), a.activeName !== void 0 && Y("tabs", "`active-name` is deprecated, please use `value` instead."), a.onActiveNameChange !== void 0 && Y("tabs", "`on-active-name-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: d,
      inlineThemeDisabled: x
    } = it(a), P = ve("Tabs", "-tabs", st, ct, a, d), g = u(null), p = u(null), H = u(null), L = u(null), f = u(null), b = u(null), z = u(!0), R = u(!0), A = ce(a, ["labelSize", "size"]), y = ce(a, ["activeName", "value"]), F = u((W = (m = y.value) !== null && m !== void 0 ? m : a.defaultValue) !== null && W !== void 0 ? W : r.default ? (_ = (v = q(r.default())[0]) === null || v === void 0 ? void 0 : v.props) === null || _ === void 0 ? void 0 : _.name : null), h = lt(y, F), l = {
      id: 0
    }, c = Z(() => {
      if (!(!a.justifyContent || a.type === "card"))
        return {
          display: "flex",
          justifyContent: a.justifyContent
        };
    });
    ee(h, () => {
      l.id = 0, V(), ie();
    });
    function E() {
      var e;
      const {
        value: t
      } = h;
      return t === null ? null : (e = g.value) === null || e === void 0 ? void 0 : e.querySelector(`[data-name="${t}"]`);
    }
    function ge(e) {
      if (a.type === "card")
        return;
      const {
        value: t
      } = p;
      if (!t)
        return;
      const n = t.style.opacity === "0";
      if (e) {
        const s = `${d.value}-tabs-bar--disabled`, {
          barWidth: o,
          placement: S
        } = a;
        if (e.dataset.disabled === "true" ? t.classList.add(s) : t.classList.remove(s), ["top", "bottom"].includes(S)) {
          if (se(["top", "maxHeight", "height"]), typeof o == "number" && e.offsetWidth >= o) {
            const C = Math.floor((e.offsetWidth - o) / 2) + e.offsetLeft;
            t.style.left = `${C}px`, t.style.maxWidth = `${o}px`;
          } else
            t.style.left = `${e.offsetLeft}px`, t.style.maxWidth = `${e.offsetWidth}px`;
          t.style.width = "8192px", n && (t.style.transition = "none"), t.offsetWidth, n && (t.style.transition = "", t.style.opacity = "1");
        } else {
          if (se(["left", "maxWidth", "width"]), typeof o == "number" && e.offsetHeight >= o) {
            const C = Math.floor((e.offsetHeight - o) / 2) + e.offsetTop;
            t.style.top = `${C}px`, t.style.maxHeight = `${o}px`;
          } else
            t.style.top = `${e.offsetTop}px`, t.style.maxHeight = `${e.offsetHeight}px`;
          t.style.height = "8192px", n && (t.style.transition = "none"), t.offsetHeight, n && (t.style.transition = "", t.style.opacity = "1");
        }
      }
    }
    function ye() {
      if (a.type === "card")
        return;
      const {
        value: e
      } = p;
      e && (e.style.opacity = "0");
    }
    function se(e) {
      const {
        value: t
      } = p;
      if (t)
        for (const n of e)
          t.style[n] = "";
    }
    function V() {
      if (a.type === "card")
        return;
      const e = E();
      e ? ge(e) : ye();
    }
    function ie() {
      var e;
      const t = (e = f.value) === null || e === void 0 ? void 0 : e.$el;
      if (!t)
        return;
      const n = E();
      if (!n)
        return;
      const {
        scrollLeft: s,
        offsetWidth: o
      } = t, {
        offsetLeft: S,
        offsetWidth: C
      } = n;
      s > S ? t.scrollTo({
        top: 0,
        left: S,
        behavior: "smooth"
      }) : S + C > s + o && t.scrollTo({
        top: 0,
        left: S + C - o,
        behavior: "smooth"
      });
    }
    const M = u(null);
    let N = 0, w = null;
    function Se(e) {
      const t = M.value;
      if (t) {
        N = e.getBoundingClientRect().height;
        const n = `${N}px`, s = () => {
          t.style.height = n, t.style.maxHeight = n;
        };
        w ? (s(), w(), w = null) : w = s;
      }
    }
    function Ce(e) {
      const t = M.value;
      if (t) {
        const n = e.getBoundingClientRect().height, s = () => {
          document.body.offsetHeight, t.style.maxHeight = `${n}px`, t.style.height = `${Math.max(N, n)}px`;
        };
        w ? (w(), w = null, s()) : w = s;
      }
    }
    function xe() {
      const e = M.value;
      if (e) {
        e.style.maxHeight = "", e.style.height = "";
        const {
          paneWrapperStyle: t
        } = a;
        if (typeof t == "string")
          e.style.cssText = t;
        else if (t) {
          const {
            maxHeight: n,
            height: s
          } = t;
          n !== void 0 && (e.style.maxHeight = n), s !== void 0 && (e.style.height = s);
        }
      }
    }
    const le = {
      value: []
    }, oe = u("next");
    function Re(e) {
      const t = h.value;
      let n = "next";
      for (const s of le.value) {
        if (s === t)
          break;
        if (s === e) {
          n = "prev";
          break;
        }
      }
      oe.value = n, $e(e);
    }
    function $e(e) {
      const {
        onActiveNameChange: t,
        onUpdateValue: n,
        "onUpdate:value": s
      } = a;
      t && G(t, e), n && G(n, e), s && G(s, e), F.value = e;
    }
    function Te(e) {
      const {
        onClose: t
      } = a;
      t && G(t, e);
    }
    function re() {
      const {
        value: e
      } = p;
      if (!e)
        return;
      const t = "transition-disabled";
      e.classList.add(t), V(), e.classList.remove(t);
    }
    const B = u(null);
    function K({
      transitionDisabled: e
    }) {
      const t = g.value;
      if (!t)
        return;
      e && t.classList.add("transition-disabled");
      const n = E();
      n && B.value && (B.value.style.width = `${n.offsetWidth}px`, B.value.style.height = `${n.offsetHeight}px`, B.value.style.transform = `translateX(${n.offsetLeft - rt(getComputedStyle(t).paddingLeft)}px)`, e && B.value.offsetWidth), e && t.classList.remove("transition-disabled");
    }
    ee([h], () => {
      a.type === "segment" && te(() => {
        K({
          transitionDisabled: !1
        });
      });
    }), pt(() => {
      a.type === "segment" && K({
        transitionDisabled: !0
      });
    });
    let de = 0;
    function Pe(e) {
      var t;
      if (e.contentRect.width === 0 && e.contentRect.height === 0 || de === e.contentRect.width)
        return;
      de = e.contentRect.width;
      const {
        type: n
      } = a;
      if ((n === "line" || n === "bar") && re(), n !== "segment") {
        const {
          placement: s
        } = a;
        X((s === "top" || s === "bottom" ? (t = f.value) === null || t === void 0 ? void 0 : t.$el : b.value) || null);
      }
    }
    const We = J(Pe, 64);
    ee([() => a.justifyContent, () => a.size], () => {
      te(() => {
        const {
          type: e
        } = a;
        (e === "line" || e === "bar") && re();
      });
    });
    const j = u(!1);
    function Le(e) {
      var t;
      const {
        target: n,
        contentRect: {
          width: s,
          height: o
        }
      } = e, S = n.parentElement.parentElement.offsetWidth, C = n.parentElement.parentElement.offsetHeight, {
        placement: D
      } = a;
      if (!j.value)
        D === "top" || D === "bottom" ? S < s && (j.value = !0) : C < o && (j.value = !0);
      else {
        const {
          value: I
        } = L;
        if (!I)
          return;
        D === "top" || D === "bottom" ? S - s > I.$el.offsetWidth && (j.value = !1) : C - o > I.$el.offsetHeight && (j.value = !1);
      }
      X(((t = f.value) === null || t === void 0 ? void 0 : t.$el) || null);
    }
    const ze = J(Le, 64);
    function Ee() {
      const {
        onAdd: e
      } = a;
      e && e(), te(() => {
        const t = E(), {
          value: n
        } = f;
        !t || !n || n.scrollTo({
          left: t.offsetLeft,
          top: 0,
          behavior: "smooth"
        });
      });
    }
    function X(e) {
      if (!e)
        return;
      const {
        placement: t
      } = a;
      if (t === "top" || t === "bottom") {
        const {
          scrollLeft: n,
          scrollWidth: s,
          offsetWidth: o
        } = e;
        z.value = n <= 0, R.value = n + o >= s;
      } else {
        const {
          scrollTop: n,
          scrollHeight: s,
          offsetHeight: o
        } = e;
        z.value = n <= 0, R.value = n + o >= s;
      }
    }
    const we = J((e) => {
      X(e.target);
    }, 64);
    bt(nt, {
      triggerRef: T(a, "trigger"),
      tabStyleRef: T(a, "tabStyle"),
      tabClassRef: T(a, "tabClass"),
      addTabStyleRef: T(a, "addTabStyle"),
      addTabClassRef: T(a, "addTabClass"),
      paneClassRef: T(a, "paneClass"),
      paneStyleRef: T(a, "paneStyle"),
      mergedClsPrefixRef: d,
      typeRef: T(a, "type"),
      closableRef: T(a, "closable"),
      valueRef: h,
      tabChangeIdRef: l,
      onBeforeLeaveRef: T(a, "onBeforeLeave"),
      activateTab: Re,
      handleClose: Te,
      handleAdd: Ee
    }), ot(() => {
      V(), ie();
    }), pe(() => {
      const {
        value: e
      } = H;
      if (!e)
        return;
      const {
        value: t
      } = d, n = `${t}-tabs-nav-scroll-wrapper--shadow-start`, s = `${t}-tabs-nav-scroll-wrapper--shadow-end`;
      z.value ? e.classList.remove(n) : e.classList.add(n), R.value ? e.classList.remove(s) : e.classList.add(s);
    });
    const _e = {
      syncBarPosition: () => {
        V();
      }
    }, Ae = () => {
      K({
        transitionDisabled: !0
      });
    }, fe = Z(() => {
      const {
        value: e
      } = A, {
        type: t
      } = a, n = {
        card: "Card",
        bar: "Bar",
        line: "Line",
        segment: "Segment"
      }[t], s = `${e}${n}`, {
        self: {
          barColor: o,
          closeIconColor: S,
          closeIconColorHover: C,
          closeIconColorPressed: D,
          tabColor: I,
          tabBorderColor: He,
          paneTextColor: Be,
          tabFontWeight: je,
          tabBorderRadius: Oe,
          tabFontWeightActive: De,
          colorSegment: Fe,
          fontWeightStrong: Ie,
          tabColorSegment: Ve,
          closeSize: Me,
          closeIconSize: ke,
          closeColorHover: Ue,
          closeColorPressed: Ge,
          closeBorderRadius: Ne,
          [$("panePadding", e)]: k,
          [$("tabPadding", s)]: Ke,
          [$("tabPaddingVertical", s)]: Xe,
          [$("tabGap", s)]: qe,
          [$("tabGap", `${s}Vertical`)]: Je,
          [$("tabTextColor", t)]: Qe,
          [$("tabTextColorActive", t)]: Ye,
          [$("tabTextColorHover", t)]: Ze,
          [$("tabTextColorDisabled", t)]: et,
          [$("tabFontSize", e)]: tt
        },
        common: {
          cubicBezierEaseInOut: at
        }
      } = P.value;
      return {
        "--n-bezier": at,
        "--n-color-segment": Fe,
        "--n-bar-color": o,
        "--n-tab-font-size": tt,
        "--n-tab-text-color": Qe,
        "--n-tab-text-color-active": Ye,
        "--n-tab-text-color-disabled": et,
        "--n-tab-text-color-hover": Ze,
        "--n-pane-text-color": Be,
        "--n-tab-border-color": He,
        "--n-tab-border-radius": Oe,
        "--n-close-size": Me,
        "--n-close-icon-size": ke,
        "--n-close-color-hover": Ue,
        "--n-close-color-pressed": Ge,
        "--n-close-border-radius": Ne,
        "--n-close-icon-color": S,
        "--n-close-icon-color-hover": C,
        "--n-close-icon-color-pressed": D,
        "--n-tab-color": I,
        "--n-tab-font-weight": je,
        "--n-tab-font-weight-active": De,
        "--n-tab-padding": Ke,
        "--n-tab-padding-vertical": Xe,
        "--n-tab-gap": qe,
        "--n-tab-gap-vertical": Je,
        "--n-pane-padding-left": U(k, "left"),
        "--n-pane-padding-right": U(k, "right"),
        "--n-pane-padding-top": U(k, "top"),
        "--n-pane-padding-bottom": U(k, "bottom"),
        "--n-font-weight-strong": Ie,
        "--n-tab-color-segment": Ve
      };
    }), O = x ? dt("tabs", Z(() => `${A.value[0]}${a.type[0]}`), fe, a) : void 0;
    return Object.assign({
      mergedClsPrefix: d,
      mergedValue: h,
      renderedNames: /* @__PURE__ */ new Set(),
      segmentCapsuleElRef: B,
      tabsPaneWrapperRef: M,
      tabsElRef: g,
      barElRef: p,
      addTabInstRef: L,
      xScrollInstRef: f,
      scrollWrapperElRef: H,
      addTabFixed: j,
      tabWrapperStyle: c,
      handleNavResize: We,
      mergedSize: A,
      handleScroll: we,
      handleTabsResize: ze,
      cssVars: x ? void 0 : fe,
      themeClass: O == null ? void 0 : O.themeClass,
      animationDirection: oe,
      renderNameListRef: le,
      yScrollElRef: b,
      handleSegmentResize: Ae,
      onAnimationBeforeLeave: Se,
      onAnimationEnter: Ce,
      onAnimationAfterEnter: xe,
      onRender: O == null ? void 0 : O.onRender
    }, _e);
  },
  render() {
    const {
      mergedClsPrefix: a,
      type: r,
      placement: m,
      addTabFixed: W,
      addable: v,
      mergedSize: _,
      renderNameListRef: d,
      onRender: x,
      paneWrapperClass: P,
      paneWrapperStyle: g,
      $slots: {
        default: p,
        prefix: H,
        suffix: L
      }
    } = this;
    x == null || x();
    const f = p ? q(p()).filter((l) => l.type.__TAB_PANE__ === !0) : [], b = p ? q(p()).filter((l) => l.type.__TAB__ === !0) : [], z = !b.length, R = r === "card", A = r === "segment", y = !R && !A && this.justifyContent;
    d.value = [];
    const F = () => {
      const l = i("div", {
        style: this.tabWrapperStyle,
        class: `${a}-tabs-wrapper`
      }, y ? null : i("div", {
        class: `${a}-tabs-scroll-padding`,
        style: m === "top" || m === "bottom" ? {
          width: `${this.tabsPadding}px`
        } : {
          height: `${this.tabsPadding}px`
        }
      }), z ? f.map((c, E) => (d.value.push(c.props.name), ae(i(ne, Object.assign({}, c.props, {
        internalCreatedByPane: !0,
        internalLeftPadded: E !== 0 && (!y || y === "center" || y === "start" || y === "end")
      }), c.children ? {
        default: c.children.tab
      } : void 0)))) : b.map((c, E) => (d.value.push(c.props.name), ae(E !== 0 && !y ? me(c) : c))), !W && v && R ? he(v, (z ? f.length : b.length) !== 0) : null, y ? null : i("div", {
        class: `${a}-tabs-scroll-padding`,
        style: {
          width: `${this.tabsPadding}px`
        }
      }));
      return i("div", {
        ref: "tabsElRef",
        class: `${a}-tabs-nav-scroll-content`
      }, R && v ? i(Q, {
        onResize: this.handleTabsResize
      }, {
        default: () => l
      }) : l, R ? i("div", {
        class: `${a}-tabs-pad`
      }) : null, R ? null : i("div", {
        ref: "barElRef",
        class: `${a}-tabs-bar`
      }));
    }, h = A ? "top" : m;
    return i("div", {
      class: [`${a}-tabs`, this.themeClass, `${a}-tabs--${r}-type`, `${a}-tabs--${_}-size`, y && `${a}-tabs--flex`, `${a}-tabs--${h}`],
      style: this.cssVars
    }, i("div", {
      class: [
        // the class should be applied here since it's possible
        // to make tabs nested in tabs, style may influence each
        // other. adding a class will make it easy to write the
        // style.
        `${a}-tabs-nav--${r}-type`,
        `${a}-tabs-nav--${h}`,
        `${a}-tabs-nav`
      ]
    }, ue(H, (l) => l && i("div", {
      class: `${a}-tabs-nav__prefix`
    }, l)), A ? i(Q, {
      onResize: this.handleSegmentResize
    }, {
      default: () => i("div", {
        class: `${a}-tabs-rail`,
        ref: "tabsElRef"
      }, i("div", {
        class: `${a}-tabs-capsule`,
        ref: "segmentCapsuleElRef"
      }, i("div", {
        class: `${a}-tabs-wrapper`
      }, i("div", {
        class: `${a}-tabs-tab`
      }))), z ? f.map((l, c) => (d.value.push(l.props.name), i(ne, Object.assign({}, l.props, {
        internalCreatedByPane: !0,
        internalLeftPadded: c !== 0
      }), l.children ? {
        default: l.children.tab
      } : void 0))) : b.map((l, c) => (d.value.push(l.props.name), c === 0 ? l : me(l))))
    }) : i(Q, {
      onResize: this.handleNavResize
    }, {
      default: () => i("div", {
        class: `${a}-tabs-nav-scroll-wrapper`,
        ref: "scrollWrapperElRef"
      }, ["top", "bottom"].includes(h) ? i(ft, {
        ref: "xScrollInstRef",
        onScroll: this.handleScroll
      }, {
        default: F
      }) : i("div", {
        class: `${a}-tabs-nav-y-scroll`,
        onScroll: this.handleScroll,
        ref: "yScrollElRef"
      }, F()))
    }), W && v && R ? he(v, !0) : null, ue(L, (l) => l && i("div", {
      class: `${a}-tabs-nav__suffix`
    }, l))), z && (this.animated && (h === "top" || h === "bottom") ? i("div", {
      ref: "tabsPaneWrapperRef",
      style: g,
      class: [`${a}-tabs-pane-wrapper`, P]
    }, be(f, this.mergedValue, this.renderedNames, this.onAnimationBeforeLeave, this.onAnimationEnter, this.onAnimationAfterEnter, this.animationDirection)) : be(f, this.mergedValue, this.renderedNames)));
  }
});
function be(a, r, m, W, v, _, d) {
  const x = [];
  return a.forEach((P) => {
    const {
      name: g,
      displayDirective: p,
      "display-directive": H
    } = P.props, L = (b) => p === b || H === b, f = r === g;
    if (P.key !== void 0 && (P.key = g), f || L("show") || L("show:lazy") && m.has(g)) {
      m.has(g) || m.add(g);
      const b = !L("if");
      x.push(b ? ht(P, [[vt, f]]) : P);
    }
  }), d ? i(gt, {
    name: `${d}-transition`,
    onBeforeLeave: W,
    onEnter: v,
    onAfterEnter: _
  }, {
    default: () => x
  }) : x;
}
function he(a, r) {
  return i(ne, {
    ref: "addTabInstRef",
    key: "__addable",
    name: "__addable",
    internalCreatedByPane: !0,
    internalAddable: !0,
    internalLeftPadded: r,
    disabled: typeof a == "object" && a.disabled
  });
}
function me(a) {
  const r = mt(a);
  return r.props ? r.props.internalLeftPadded = !0 : r.props = {
    internalLeftPadded: !0
  }, r;
}
function ae(a) {
  return Array.isArray(a.dynamicProps) ? a.dynamicProps.includes("internalLeftPadded") || a.dynamicProps.push("internalLeftPadded") : a.dynamicProps = ["internalLeftPadded"], a;
}
export {
  kt as default,
  yt as tabsProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tabs/src/Tabs.js
// module id = 972
// module chunks = 67